import { render, staticRenderFns } from "./JSelectCate.vue?vue&type=template&id=6824b1b4&scoped=true"
import script from "./JSelectCate.vue?vue&type=script&lang=js"
export * from "./JSelectCate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6824b1b4",
  null
  
)

export default component.exports